export default __webpack_public_path__ + "static/blob10-30537f86e918d58e05c135fb1e81e93f.svg";